import { createContext, useContext, useState, ReactNode } from "react";

interface ChatContextType {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  pendingPrompt: string | null;
  openWithPrompt: (prompt: string) => void;
  clearPendingPrompt: () => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export function ChatProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [pendingPrompt, setPendingPrompt] = useState<string | null>(null);

  const openWithPrompt = (prompt: string) => {
    setPendingPrompt(prompt);
    setIsOpen(true);
  };

  const clearPendingPrompt = () => {
    setPendingPrompt(null);
  };

  return (
    <ChatContext.Provider value={{ isOpen, setIsOpen, pendingPrompt, openWithPrompt, clearPendingPrompt }}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChat() {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return context;
}
